import React, {useState, useEffect} from "react";
import PortableText from "./portableText";
import sanityClient from "@sanity/client";
import clientConfig from "../../client-config";
import * as styles from './blogHero.module.css';
import CategoryPreview from './categoryPreview.js';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function BlogHero(props) {

    let featuredClass1 = styles.featuredItem;
    let featuredClass2 = styles.featuredItem + ' ' + styles.featuredItemInverse;

    let featuredImg1 = maybeImage(props.featuredItem1Image);
    let featuredImg2 = maybeImage(props.featuredItem2Image);

    const client = sanityClient(clientConfig.sanity);

    const [categories, setCategory] = useState([]);
    
    useEffect(() => {
        client
        .fetch(
            `*[_type == "category"] {
            title,
            "posts": *[_type == "post" && references(^._id)]{
                title,
                excerpt,
                slug,
                mainImage
            }
        }`
        )
        .then((data) => setCategory(data))
        .catch(console.error)
    }, []);

    return (
        <>
            <div className={styles.sectionBlogHero}>
                <div className={styles.bgCircle}>
                    <img src={require('../images/hero_circle.png').default} alt="Homesta Circle" />
                </div>
                <div className={styles.sectionContent}>
                    <h1>{props.heading}</h1>
                    <div className={styles.iframeWrapper}>
                        <iframe width="1080" height="615" src={props.embedVideoLink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            <div className={styles.featuredItems}>

                <div className={featuredClass1}>
                    <div className={styles.featuredBgCircle}>
                        <img src={require('../images/hero_circle.png').default} alt="Homesta Circle" />
                    </div>
                    <div className={styles.featuredContainer}>
                        <div className={styles.featuredImageCell}>
                            {featuredImg1}
                        </div>
                        <div className={styles.featuredContentCell}>
                            <h3>{props.featuredItem1Title}</h3>
                            <div className={styles.contentWrap}>
                                <PortableText blocks={props.featuredItem1Content} />
                            </div>
                            <a href={props.featuredItem1Link} className={styles.featuredCta}>
                                <span class="inline-block align-middle">{props.featuredItem1LinkLabel}</span>
                                <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className={featuredClass2}>
                    <div className={styles.featuredBgCircle}>
                        <img src={require('../images/hero_circle.png').default} alt="Homesta Circle" />
                    </div>
                    <div className={styles.featuredContainer}>
                        <div className={styles.featuredImageCell}>
                            {featuredImg2}
                        </div>
                        <div className={styles.featuredContentCell}>
                            <h3>{props.featuredItem2Title}</h3>
                            <div className={styles.contentWrap}>
                                <PortableText blocks={props.featuredItem2Content} />
                            </div>
                            <a href={props.featuredItem2Link} className={styles.featuredCta}>
                                <span class="inline-block align-middle">{props.featuredItem2LinkLabel}</span>
                                <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                            </a>
                        </div>
                    </div>
                </div>

            </div>

            {
                categories.map((item, i) => {  
                    return <CategoryPreview category={item} />
                })
            }

        </>
    );
}

export default BlogHero;
